import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

const propTypes = {
  input: PropTypes.shape({ name: PropTypes.string }).isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  disabled: PropTypes.bool.isRequired,
};

const useStyles = makeStyles(() => ({
  selectElement: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

function WrappedSelectField({
  input,
  label,
  className,
  meta: { touched, error },
  children,
  disabled,
}) {
  const classes = useStyles();
  const labelString = label.replace(/\s/g, '');
  return (
    <FormControl
      className={className}
      error={touched && error}
      variant="outlined"
      disabled={disabled}
    >
      <InputLabel htmlFor={`${labelString}`}>{label}</InputLabel>
      <Select
        classes={{ select: classes.selectElement }}
        autoWidth
        MenuProps={{
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
          getContentAnchorEl: null,
        }}
        defaultValue=""
        {...input}
        label={label}
        inputProps={{
          name: input.name,
          id: `${labelString}`,
        }}
      >
        {children}
      </Select>
    </FormControl>
  );
}

WrappedSelectField.propTypes = propTypes;

export default WrappedSelectField;
